import React, { useEffect, useState } from "react";
import axios from "axios";
import { GlobalSet } from '../../global/GlobalProvider';

export default function ArbTrade() {
  const [rows, setRows] = useState([]);
  const { BaseUrl } = GlobalSet();

  const fetchData = () => {
    axios.get("https://backoffice.segma.app/api/apps-arb-trade")
      .then(res => {
        if (res.data.status === "success") setRows(res.data.data);
      })
      .catch(err => console.log(err));
  };

  useEffect(() => {
    fetchData(); // first load
    const interval = setInterval(fetchData, 2000); // reload every 2 sec
    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{ background:"#ffffff", minHeight:"100vh", padding:"25px", color:"#000" }}>
      <h2 style={{ textAlign:"center", marginBottom:"20px", color:"#000" }}>
        ARB TRADE LIVE FEED
      </h2>

      {/* CSS Animations */}
      <style>{`
        .row-anim {
          animation: slideFade 0.6s ease;
        }
        @keyframes slideFade {
          from { opacity:0; transform: translateY(8px); }
          to { opacity:1; transform: translateY(0); }
        }

        .moving-icon {
          display: inline-block;
          animation: moveSide 3s linear infinite;
        }
        @keyframes moveSide {
          0% { transform: translateX(0); }
          50% { transform: translateX(5px); }
          100% { transform: translateX(0); }
        }

        /* Pulse for BUY */
        .buy-flash {
          animation: pulseGreen 1s ease infinite;
        }
        @keyframes pulseGreen {
          0%, 100% { color: #0f9d58; }
          50% { color: #28d094; }
        }

        /* Pulse for SELL */
        .sell-flash {
          animation: pulseRed 1s ease infinite;
        }
        @keyframes pulseRed {
          0%, 100% { color: #d93025; }
          50% { color: #ff4c4c; }
        }
      `}</style>

      <div style={{ width:"100%", overflowX:"auto" }}>
        <table style={{ width:"100%", borderCollapse:"collapse", minWidth:"1100px", color:"#000" }}>
          <thead>
            <tr style={{ background:"#e6e6e6" }}>
              <th style={th}>SL</th>
              <th style={th}>Exchange</th>
              <th style={th}>Amount</th>
              <th style={th}>Type</th>
              <th style={th}>Hash</th>
              <th style={th}>Received</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, i) => (
              <tr key={row.id} className="row-anim" style={{ background: i % 2 ? "#f7f7f7" : "#ffffff" }}>
                <td style={td}>{i + 1}</td>

                {/* Exchange with moving icon */}
                <td style={td}>
                  <img src={BaseUrl + row.exchange_logo}
                    className="moving-icon"
                    style={{ width:28, height:28, borderRadius:"50%", objectFit:"cover", marginRight:6, verticalAlign:"middle", background:"#fff" }}
                  />
                  {row.exchanges}
                </td>

                {/* Amount with coin icon moving */}
                <td style={td}>
                  <img src={BaseUrl + row.coin_logo}
                    className="moving-icon"
                    style={{ width:24, height:24, borderRadius:"50%", objectFit:"cover", marginRight:6, verticalAlign:"middle" }}
                  />
                  {row.btc_amount} {row.coin}
                </td>

                {/* Trade type with pulse color */}
                <td style={{ ...td, fontWeight:"700" }} className={row.trade_type.toLowerCase() === "buy" ? "buy-flash" : "sell-flash"}>
                  {row.trade_type.toUpperCase()}
                </td>

                {/* Hash */}
                <td style={{ ...td, maxWidth:"250px", whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>
                  {row.hash}
                </td>

                {/* Received */}
                <td style={td}>{row.created_at}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const th = { padding:"12px 10px", textAlign:"center", fontWeight:"600", fontSize:"14px" };
const td = { padding:"10px", textAlign:"center", fontSize:"14px" };
